import React from "react";

/**
 * Simple blog cover — just the blog's own image with a small tag sticker.
 * One unique millet / subject photo per blog. No pop-art, no overlays.
 */

export default function BlogCover({ blog, className = "" }) {
  return (
    <div
      data-testid={`blog-cover-${blog.slug}`}
      className={`relative h-full w-full overflow-hidden bg-cream ${className}`}
    >
      <img
        src={blog.image}
        alt={blog.title}
        loading="lazy"
        className="h-full w-full object-cover"
      />
      <div
        data-testid={`blog-cover-tag-${blog.slug}`}
        className="absolute bottom-3 left-3 rounded-full border-2 border-jet bg-cream px-3 py-1 font-sans text-[10px] font-black uppercase tracking-[0.22em] text-jet"
      >
        § {blog.tag}
      </div>
    </div>
  );
}
